import { toast } from "react-toastify";

export function successAlert(message: string): void {
  toast.success(message);
};

export function errorAlert(message: string): void {
  toast.error(message);
};
